// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --setup-teal: var(--interactive-default);
  --setup-teal-hover: var(--interactive-hover);
  --setup-teal-active: var(--interactive-pressed);
  --setup-teal-light: var(--interactive-soft);
  --setup-teal-pill: var(--interactive-selected);
  --setup-text: var(--text-primary);
  --setup-secondary: var(--text-secondary);
  --setup-border: var(--border-default);
  --setup-input-border: var(--border-strong);
  --setup-disabled: var(--interactive-disabled);
  --setup-error: var(--danger-default);
  --font-family-primary: "Lexend", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }

.business-setup-page {
  --setup-teal: var(--interactive-default);
  --setup-teal-hover: var(--interactive-hover);
  --setup-teal-active: var(--interactive-pressed);
  --setup-teal-light: var(--interactive-soft);
  --setup-teal-pill: var(--interactive-selected);
  --setup-text: var(--text-primary);
  --setup-secondary: var(--text-secondary);
  --setup-border: var(--border-default);
  --setup-input-border: var(--border-strong);
  --setup-disabled: var(--interactive-disabled);
  --setup-error: var(--danger-default);
  --font-family-primary: "Lexend", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  display: flex;
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  background: var(--surface-primary);
  color: var(--setup-text);
  font-family: var(--font-family-primary);
  box-sizing: border-box; }
  .business-setup-page *,
  .business-setup-page *::before,
  .business-setup-page *::after {
    box-sizing: border-box; }

/* ==========================================================================
   Left Branding Column (Figma: Branding Panel 736x900)
   ========================================================================== */
.business-setup-brand {
  position: relative;
  width: 51.111%;
  height: 100vh;
  overflow: hidden;
  padding: clamp(28px, 4.5vh, 64px) clamp(32px, 4vw, 72px);
  color: #ffffff;
  background: linear-gradient(90deg, #2ee6ee 0%, #0fbac4 45%, #0a7489 100%);
  display: flex;
  flex-direction: column;
  flex-shrink: 0; }

.business-setup-brand-content {
  position: relative;
  z-index: 1;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  min-height: 0; }

.business-setup-brand-logo {
  width: 262px;
  height: 57px;
  object-fit: contain;
  flex-shrink: 0; }

.business-setup-brand-copy {
  margin-top: clamp(16px, 2.8vh, 32px); }

.business-setup-brand-copy h1 {
  max-width: 576px;
  margin: 0;
  font-size: clamp(32px, 4.2vh, 54px);
  font-weight: 700;
  line-height: 1.18;
  letter-spacing: -1.5px;
  color: #ffffff; }

.business-setup-brand-copy p {
  max-width: 520px;
  margin: clamp(12px, 1.8vh, 20px) 0 0;
  font-size: clamp(15px, 1.8vh, 18px);
  font-weight: 400;
  line-height: 1.55;
  color: #ffffff; }

.business-setup-progress {
  display: grid;
  margin: clamp(16px, 3vh, 36px) 0 0;
  padding: 0;
  list-style: none; }

.business-setup-progress li {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: clamp(52px, 6.5vh, 72px);
  padding: 0 12px; }
  .business-setup-progress li:not(:last-child)::after {
    position: absolute;
    top: 48px;
    left: 27px;
    width: 1px;
    height: clamp(24px, 3.5vh, 40px);
    background: rgba(255, 255, 255, 0.55);
    content: ""; }
  .business-setup-progress li > span {
    display: grid;
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    place-items: center;
    border: 1px solid #ffffff;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.13);
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    color: #ffffff;
    transition: all 0.2s ease; }
  .business-setup-progress li.is-active > span {
    background: #ffffff;
    color: #0fbac4;
    border-color: #ffffff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12); }
  .business-setup-progress li div {
    display: grid;
    gap: 2px; }
  .business-setup-progress li strong {
    font-size: 16px;
    font-weight: 500;
    line-height: 21px;
    color: #ffffff; }
  .business-setup-progress li small {
    color: rgba(255, 255, 255, 0.82);
    font-size: 12px;
    line-height: 17px; }

.business-setup-secure {
  margin-top: auto;
  padding-top: 16px;
  font-size: 12px;
  line-height: 16px;
  color: #ffffff;
  opacity: 0.92; }

/* Background floating orbs */
.business-setup-orb {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  background: rgba(255, 255, 255, 0.1); }

.business-setup-orb--one {
  width: 516px;
  height: 516px;
  top: -205px;
  left: -178px; }

.business-setup-orb--two {
  width: 140px;
  height: 140px;
  top: -60px;
  right: -70px; }

.business-setup-orb--three {
  width: 416px;
  height: 416px;
  right: -208px;
  bottom: -274px;
  background: rgba(5, 78, 104, 0.12); }

/* ==========================================================================
   Right Form Panel (Figma: Form Panel · Business setup 704x900)
   ========================================================================== */
.business-setup-panel {
  position: relative;
  display: flex;
  width: 48.889%;
  height: 100vh;
  flex-direction: column;
  justify-content: space-between;
  padding: clamp(20px, 3.5vh, 48px) clamp(24px, 4vw, 64px);
  background: var(--surface-primary);
  overflow-y: auto;
  overflow-x: hidden; }

.business-setup-form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-width: 576px;
  margin: 0 auto;
  flex: 1 0 auto;
  min-height: 0; }

.business-setup-content {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: clamp(14px, 2vh, 22px); }

/* Headings (Figma: Screen Heading) */
.business-setup-heading {
  display: grid;
  gap: 6px; }

.business-setup-step-row {
  display: flex;
  min-height: 32px;
  align-items: center;
  justify-content: space-between;
  color: var(--setup-teal);
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.07px; }

.business-setup-skip-btn {
  border: 0;
  padding: 6px 12px;
  color: var(--setup-teal);
  background: transparent;
  font: 500 13px var(--font-family-primary);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease; }
  .business-setup-skip-btn:hover:not(:disabled) {
    background: var(--setup-teal-light);
    color: var(--setup-teal-hover); }
  .business-setup-skip-btn:active:not(:disabled) {
    background: var(--interactive-selected);
    color: var(--setup-teal-active); }
  .business-setup-skip-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed; }

.business-setup-heading h2 {
  margin: 0;
  font-size: clamp(28px, 3.5vh, 40px);
  font-weight: 300;
  line-height: 1.2;
  letter-spacing: -0.6px;
  color: var(--setup-text); }

.business-setup-heading p {
  margin: 0;
  color: var(--setup-secondary);
  font-size: 14px;
  line-height: 1.5; }

/* Fields Stack (Figma: Business identity form) */
.business-setup-fields {
  display: grid;
  gap: clamp(10px, 1.6vh, 16px); }

/* Logo Upload Container */
.business-logo-upload {
  display: flex;
  min-height: 76px;
  align-items: center;
  gap: 14px;
  padding: 10px 14px;
  border: 1px solid var(--setup-border);
  border-radius: 14px;
  background: var(--surface-primary);
  transition: border-color 0.15s ease; }
  .business-logo-upload:hover {
    border-color: var(--border-strong); }

.business-logo-avatar {
  display: grid;
  width: 52px;
  height: 52px;
  flex: 0 0 52px;
  place-items: center;
  overflow: hidden;
  border-radius: 50%;
  background: var(--setup-teal-light);
  color: var(--setup-teal); }
  .business-logo-avatar svg {
    width: 26px;
    height: 26px; }
  .business-logo-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover; }

.business-logo-info {
  display: grid;
  flex: 1 1;
  gap: 2px;
  min-width: 0; }

.business-logo-title-row {
  display: flex;
  align-items: center;
  gap: 8px; }
  .business-logo-title-row strong {
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    color: var(--setup-text); }

.business-logo-optional-tag {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: var(--text-secondary); }

.business-logo-info small,
.business-setup-field small {
  color: var(--setup-secondary);
  font-size: 13px;
  line-height: 16px; }

.business-logo-upload-btn {
  height: 36px;
  padding: 0 16px;
  border: 1px solid var(--setup-border);
  border-radius: 10px;
  background: var(--surface-primary);
  color: var(--setup-text);
  font: 500 13px var(--font-family-primary);
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap; }
  .business-logo-upload-btn:hover {
    background: var(--surface-secondary);
    border-color: var(--border-strong); }
  .business-logo-upload-btn:active {
    background: var(--surface-tertiary);
    border-color: var(--setup-input-border);
    transform: scale(0.98); }

/* Field Labels & Inputs */
.business-setup-field {
  display: grid;
  gap: 6px; }

.business-setup-field-label,
.business-type-field legend {
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: var(--setup-text); }

.required-marker {
  color: var(--setup-error);
  font-weight: 500; }

.business-setup-input {
  width: 100%;
  height: 48px;
  padding: 0 16px;
  border: 1px solid var(--setup-input-border);
  border-radius: 14px;
  outline: none;
  background: var(--surface-primary);
  color: var(--setup-text);
  font: 400 16px/20px var(--font-family-primary);
  transition: border-color 0.15s ease, box-shadow 0.15s ease; }
  .business-setup-input::placeholder {
    color: var(--text-secondary); }
  .business-setup-input:hover {
    border-color: var(--setup-teal); }
  .business-setup-input:focus {
    border: 2px solid var(--setup-teal);
    box-shadow: none;
    padding: 0 15px; }

.business-setup-error {
  color: var(--setup-error) !important;
  font-size: 13px !important;
  line-height: 16px !important;
  font-weight: 400; }

.business-setup-hint {
  color: var(--setup-secondary);
  font-size: 13px;
  line-height: 16px; }

/* Organisation Type Field Cards */
.business-type-field {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  border: 0; }

.business-type-cards {
  display: flex;
  gap: 16px; }

.business-type-card {
  display: flex;
  height: clamp(60px, 7.5vh, 76px);
  flex: 1 1;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  border: 1px solid var(--setup-border);
  border-radius: 14px;
  background: var(--surface-primary);
  color: var(--setup-text);
  font: 500 16px var(--font-family-primary);
  cursor: pointer;
  transition: all 0.15s ease;
  outline: none; }
  .business-type-card:hover {
    border-color: var(--interactive-default);
    background: var(--surface-secondary); }
  .business-type-card:active {
    transform: scale(0.99); }
  .business-type-card.is-selected {
    border: 1.5px solid var(--setup-teal);
    background: var(--setup-teal-light); }

.business-type-icon-box {
  display: grid;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  place-items: center;
  border-radius: 10px;
  background: var(--surface-secondary);
  color: var(--setup-secondary);
  transition: all 0.15s ease; }
  .is-selected .business-type-icon-box {
    background: var(--interactive-soft-hover);
    color: var(--setup-teal); }
  .business-type-icon-box svg {
    width: 22px;
    height: 22px; }

.business-type-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: var(--setup-text); }

.business-type-check-badge {
  display: grid;
  width: 22px;
  height: 22px;
  margin-left: auto;
  place-items: center;
  border: 1.5px solid var(--setup-border);
  border-radius: 50%;
  font-style: normal;
  background: var(--surface-primary);
  transition: all 0.15s ease; }
  .is-selected .business-type-check-badge {
    border-color: var(--setup-teal);
    background: var(--setup-teal);
    color: var(--on-interactive-primary); }
  .business-type-check-badge svg {
    width: 14px;
    height: 14px; }

.business-setup-field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px; }

.business-setup-themed-select .quotation-figma-dropdown-trigger {
  height: 48px;
  padding: 0 16px;
  border: 1px solid var(--setup-input-border);
  border-radius: 14px;
  background: var(--surface-primary);
  color: var(--setup-text);
  font: 400 14px/20px var(--font-family-primary); }
  .business-setup-themed-select .quotation-figma-dropdown-trigger:hover {
    border-color: var(--setup-teal); }

.business-setup-themed-select.is-open .quotation-figma-dropdown-trigger,
.business-setup-themed-select .quotation-figma-dropdown-trigger:focus-visible {
  border: 2px solid var(--setup-teal);
  padding-inline: 15px;
  box-shadow: none; }

.business-setup-themed-select .quotation-figma-dropdown-trigger.error {
  border-color: var(--setup-error); }

.business-setup-page .rcti-eligibility-select .quotation-figma-dropdown-trigger {
  min-height: 42px;
  height: 42px;
  padding-inline: 12px 10px;
  border-radius: 14px;
  font: 400 14px/20px var(--font-family-primary); }

/* Notice Box (Step 3: Banking) */
.business-setup-notice {
  display: flex;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 14px;
  background: var(--setup-teal-light);
  color: var(--setup-teal); }
  .business-setup-notice .notice-icon {
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
    margin-top: 1px; }
  .business-setup-notice div {
    display: grid;
    gap: 3px;
    font-size: 14px;
    line-height: 1.45; }
  .business-setup-notice strong {
    font-weight: 500;
    color: var(--setup-teal); }
  .business-setup-notice span {
    color: var(--interactive-hover);
    font-size: 13px; }

/* ==========================================================================
   Buttons & Interactive States (Figma: Button System 80:992)
   ========================================================================== */
.business-setup-actions {
  display: flex;
  gap: 12px;
  margin-top: clamp(16px, 2.5vh, 28px);
  padding-top: 0; }

.business-setup-button {
  height: 48px;
  padding: 0 24px;
  border-radius: 14px;
  font: 500 16px/20px var(--font-family-primary);
  cursor: pointer;
  transition: all 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  outline: none; }
  .business-setup-button:focus-visible {
    box-shadow: none;
    outline: 2px solid var(--focus-ring, #0f766e);
    outline-offset: 2px; }

/* Primary Button (Continue / Finish setup) */
.business-setup-button--primary {
  flex: 1 1;
  border: 0;
  background: var(--setup-teal);
  color: var(--on-interactive-primary); }
  .business-setup-button--primary:hover:not(:disabled) {
    background: var(--setup-teal-hover); }
  .business-setup-button--primary:active:not(:disabled) {
    background: var(--setup-teal-active);
    transform: scale(0.99); }
  .business-setup-button--primary:disabled {
    background: var(--setup-disabled);
    color: var(--on-interactive-disabled);
    cursor: not-allowed;
    opacity: 1; }

/* Secondary Button (Back) */
.business-setup-button--secondary {
  flex: 1 1;
  border: 1px solid var(--setup-border);
  background: var(--surface-primary);
  color: var(--setup-text); }
  .business-setup-button--secondary:hover:not(:disabled) {
    background: var(--surface-secondary);
    border-color: var(--setup-border); }
  .business-setup-button--secondary:active:not(:disabled) {
    background: var(--surface-tertiary);
    border-color: var(--setup-input-border);
    transform: scale(0.99); }
  .business-setup-button--secondary:disabled {
    background: var(--surface-primary);
    border-color: var(--border-subtle);
    color: var(--text-secondary);
    cursor: not-allowed; }

/* Button Loading Spinner */
.business-btn-spin {
  animation: spinLoader 0.9s linear infinite;
  font-size: 18px; }

@keyframes spinLoader {
  100% {
    transform: rotate(360deg); } }

/* Footer (Privacy & Terms) */
.business-setup-footer {
  position: static;
  margin-top: clamp(16px, 2vh, 24px);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  line-height: 18px; }
  .business-setup-footer a {
    color: var(--setup-teal);
    text-decoration: none;
    transition: color 0.15s ease; }
    .business-setup-footer a:hover {
      text-decoration: underline;
      color: var(--setup-teal-hover); }
  .business-setup-footer span {
    color: var(--setup-secondary); }

/* ==========================================================================
   Crop Logo Modal (Clean, Dedicated, Never Cut Off)
   ========================================================================== */
.business-crop-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  max-width: 460px;
  max-height: 90vh;
  padding: 20px 24px;
  border-radius: 16px;
  background: var(--surface-primary);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
  outline: none;
  box-sizing: border-box; }

.business-crop-header {
  display: flex;
  align-items: center;
  justify-content: space-between; }

.business-crop-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: var(--setup-text); }

.business-crop-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: var(--setup-secondary);
  cursor: pointer;
  transition: all 0.15s ease; }
  .business-crop-close-btn:hover {
    background: var(--surface-secondary);
    color: var(--setup-text); }
  .business-crop-close-btn svg {
    width: 18px;
    height: 18px; }

.business-crop-area {
  position: relative;
  width: 100%;
  height: clamp(240px, 40vh, 320px);
  border-radius: 12px;
  overflow: hidden;
  background: #0e1a18; }

.business-crop-zoom-row {
  display: flex;
  align-items: center;
  gap: 14px; }

.business-crop-zoom-label {
  font-size: 14px;
  font-weight: 500;
  color: var(--setup-text); }

.business-crop-zoom-slider {
  flex: 1 1;
  accent-color: var(--setup-teal);
  cursor: pointer;
  height: 6px; }

.business-crop-actions {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 12px !important;
  margin-top: 4px; }

.business-crop-btn {
  height: 40px;
  padding: 0 20px;
  border-radius: 10px;
  font: 500 14px/18px var(--font-family-primary);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.15s ease;
  outline: none; }

.business-crop-btn--cancel {
  border: 1px solid var(--border-default) !important;
  background: var(--surface-primary) !important;
  color: #142624 !important; }
  .business-crop-btn--cancel:hover {
    background: var(--surface-secondary) !important;
    border-color: var(--border-strong) !important; }
  .business-crop-btn--cancel:active {
    background: var(--surface-tertiary) !important;
    transform: scale(0.98); }

.business-crop-btn--save {
  border: none !important;
  background: var(--interactive-default) !important;
  color: var(--on-interactive-primary) !important; }
  .business-crop-btn--save:hover {
    background: #0c5f59 !important; }
  .business-crop-btn--save:active {
    background: #0a4a46 !important;
    transform: scale(0.98); }
  .business-crop-btn--save svg {
    font-size: 16px; }

/* ==========================================================================
   Responsive Adaptations
   ========================================================================== */
/* Short laptop screens (<= 800px height) */
@media (max-height: 800px) and (min-width: 1024px) {
  .business-setup-panel {
    padding: 20px 48px; }
  .business-setup-brand {
    padding: 24px 48px; }
  .business-setup-brand-copy h1 {
    font-size: 34px;
    line-height: 1.15; }
  .business-setup-brand-copy p {
    font-size: 14px;
    line-height: 1.45;
    margin-top: 10px; }
  .business-setup-progress {
    margin-top: 18px; }
  .business-setup-progress li {
    min-height: 54px; }
  .business-setup-heading h2 {
    font-size: 28px;
    line-height: 1.18; }
  .business-setup-fields {
    gap: 10px; }
  .business-setup-input {
    height: 44px; }
  .business-setup-themed-select .quotation-figma-dropdown-trigger {
    height: 44px; }
  .business-type-card {
    height: 58px; }
  .business-setup-button {
    height: 44px; } }

/* Tablet Flow (max-width: 1023px) */
@media (max-width: 1023px) {
  .business-setup-page {
    display: block;
    height: auto;
    max-height: none;
    overflow: auto; }
  .business-setup-brand {
    width: 100%;
    min-height: 240px;
    height: auto;
    padding: 40px 32px; }
  .business-setup-brand-content {
    min-height: 0; }
  .business-setup-brand-copy {
    margin-top: 16px; }
  .business-setup-brand-copy h1 {
    font-size: 32px;
    line-height: 42px;
    letter-spacing: -0.5px; }
  .business-setup-brand-copy p {
    margin-top: 6px;
    font-size: 14px;
    line-height: 22px; }
  .business-setup-progress,
  .business-setup-secure {
    display: none; }
  .business-setup-panel {
    width: 100%;
    height: auto;
    min-height: auto;
    padding: 48px 32px 32px; }
  .business-setup-form {
    min-height: auto; } }

/* Mobile Flow (max-width: 599px) */
@media (max-width: 599px) {
  .business-setup-brand {
    display: none; }
  .business-setup-panel {
    width: 100%;
    padding: 32px 16px 24px; }
  .business-setup-heading h2 {
    font-size: 26px;
    line-height: 32px; }
  .business-type-cards {
    gap: 8px; }
  .business-type-card {
    height: 48px;
    gap: 8px;
    padding: 8px 12px;
    font-size: 14px; }
  .business-type-icon-box {
    display: none; }
  .business-setup-field-row {
    grid-template-columns: 1fr;
    gap: 12px; }
  .business-setup-actions {
    flex-direction: column-reverse; }
  .business-setup-button--secondary {
    width: 100%; }
  .business-crop-modal {
    padding: 16px; }
  .business-crop-area {
    height: 240px; } }

.business-setup-input,
.business-setup-themed-select .quotation-figma-dropdown-trigger {
  caret-color: var(--setup-text); }

.business-setup-input:-webkit-autofill,
.business-setup-input:-webkit-autofill:hover,
.business-setup-input:-webkit-autofill:focus {
  -webkit-text-fill-color: var(--setup-text);
  -webkit-box-shadow: 0 0 0 1000px var(--surface-primary) inset;
  caret-color: var(--setup-text); }
`, "",{"version":3,"sources":["webpack://./src/layouts/authentication/sign-up/SignUp.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,wCAAa;EACb,4CAAmB;EACnB,+CAAoB;EACpB,2CAAmB;EACnB,8CAAkB;EAClB,iCAAa;EACb,wCAAkB;EAClB,qCAAe;EACf,0CAAqB;EACrB,6CAAiB;EACjB,oCAAc;EACd,kGAAsB,EAAA;;AAGxB;EACE,wCAAa;EACb,4CAAmB;EACnB,+CAAoB;EACpB,2CAAmB;EACnB,8CAAkB;EAClB,iCAAa;EACb,wCAAkB;EAClB,qCAAe;EACf,0CAAqB;EACrB,6CAAiB;EACjB,oCAAc;EACd,kGAAsB;EAEtB,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,wBAAwB;EACxB,uCAAuC;EACvC,sBAAsB,EAAA;EArBxB;;;IA0BI,sBAAsB,EAAA;;AAI1B;;+EAF+E;AAK/E;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,wDAAwD;EACxD,cAAc;EACd,yEAAyE;EACzE,aAAa;EACb,sBAAsB;EACtB,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa,EAAA;;AAGf;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc,EAAA;;AAGhB;EACE,oCAAoC,EAAA;;AAGtC;EACE,gBAAgB;EAChB,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,kCAAkC;EAClC,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,eAAe,EAAA;EANjB;IASI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,gCAAgC;IAChC,qCAAqC;IACrC,WAAW,EAAA;EAff;IAmBI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,yBAAyB,EAAA;EA/B7B;IAmCI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,yCAAyC,EAAA;EAtC7C;IA0CI,aAAa;IACb,QAAQ,EAAA;EA3CZ;IA+CI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc,EAAA;EAlDlB;IAsDI,gCAAgC;IAChC,eAAe;IACf,iBAAiB,EAAA;;AAIrB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa,EAAA;;AAGf,6BAAA;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC,EAAA;;AAGtC;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,cAAc;EACd,kCAAkC,EAAA;;AAGpC;;+EA3B+E;AA8B/E;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,wDAAwD;EACxD,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,2BAA2B,EAAA;;AAG7B,qCAAA;AACA;EACE,aAAa;EACb,QAAQ,EAAA;;AAGV;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EACT,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;EACvB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,0BAA0B,EAAA;EAR5B;IAWI,mCAAmC;IACnC,8BAA8B,EAAA;EAZlC;IAgBI,uCAAuC;IACvC,+BAA+B,EAAA;EAjBnC;IAqBI,YAAY;IACZ,mBAAmB,EAAA;;AAIvB;EACE,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB,EAAA;;AAG1B;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB,EAAA;;AAGlB,iDAAA;AACA;EACE,aAAa;EACb,6BAA6B,EAAA;;AAG/B,0BAAA;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,kCAAkC;EAClC,mCAAmC,EAAA;EATrC;IAYI,kCAAkC,EAAA;;AAItC;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,wBAAwB,EAAA;EAT1B;IAYI,WAAW;IACX,YAAY,EAAA;EAbhB;IAiBI,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAA;;AAIrB;EACE,aAAa;EACb,SAAO;EACP,QAAQ;EACR,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAA;EAHV;IAMI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB,EAAA;;AAI5B;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B,EAAA;;AAG9B;;EAEE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB,EAAA;;AAGnB;EACE,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,kCAAkC;EAClC,wBAAwB;EACxB,yCAAyC;EACzC,eAAe;EACf,0BAA0B;EAC1B,mBAAmB,EAAA;EAVrB;IAaI,oCAAoC;IACpC,kCAAkC,EAAA;EAdtC;IAkBI,mCAAmC;IACnC,uCAAuC;IACvC,sBAAsB,EAAA;;AAI1B,0BAAA;AACA;EACE,aAAa;EACb,QAAQ,EAAA;;AAGV;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB,EAAA;;AAG1B;EACE,yBAAyB;EACzB,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,wBAAwB;EACxB,8CAA8C;EAC9C,0DAA0D,EAAA;EAV5D;IAaI,4BAA4B,EAAA;EAbhC;IAiBI,+BAA+B,EAAA;EAjBnC;IAqBI,mCAAmC;IACnC,gBAAgB;IAChB,eAAe,EAAA;;AAInB;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB,EAAA;;AAGlB;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB,EAAA;;AAGnB,kCAAA;AACA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;EACT,UAAU;EACV,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,gCAAgC;EAChC,SAAO;EACP,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,kCAAkC;EAClC,wBAAwB;EACxB,yCAAyC;EACzC,eAAe;EACf,0BAA0B;EAC1B,aAAa,EAAA;EAdf;IAiBI,wCAAwC;IACxC,oCAAoC,EAAA;EAlBxC;IAsBI,sBAAsB,EAAA;EAtB1B;IA0BI,qCAAqC;IACrC,mCAAmC,EAAA;;AAIvC;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B,EAAA;EAE1B;IACE,yCAAyC;IACzC,wBAAwB,EAAA;EAb5B;IAiBI,WAAW;IACX,YAAY,EAAA;;AAIhB;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB,EAAA;;AAG1B;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B,EAAA;EAE1B;IACE,+BAA+B;IAC/B,6BAA6B;IAC7B,oCAAoC,EAAA;EAfxC;IAmBI,WAAW;IACX,YAAY,EAAA;;AAIhB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS,EAAA;;AAGX;EACE,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,kCAAkC;EAClC,wBAAwB;EACxB,8CAA8C,EAAA;EAPhD;IASI,+BAA+B,EAAA;;AAInC;;EAEE,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB,EAAA;;AAGlB;EACE,gCAAgC,EAAA;;AAGlC;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C,EAAA;;AAGhD,iCAAA;AACA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,wBAAwB,EAAA;EAN1B;IASI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe,EAAA;EAZnB;IAgBI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,iBAAiB,EAAA;EAnBrB;IAuBI,gBAAgB;IAChB,wBAAwB,EAAA;EAxB5B;IA4BI,+BAA+B;IAC/B,eAAe,EAAA;;AAInB;;+EA5G+E;AA+G/E;EACE,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,cAAc,EAAA;;AAGhB;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,8CAA8C;EAC9C,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa,EAAA;EAXf;IAcI,gBAAgB;IAChB,6CAA6C;IAC7C,mBAAmB,EAAA;;AAIvB,6CAAA;AACA;EACE,SAAO;EACP,SAAS;EACT,6BAA6B;EAC7B,oCAAoC,EAAA;EAJtC;IAOI,mCAAmC,EAAA;EAPvC;IAWI,oCAAoC;IACpC,sBAAsB,EAAA;EAZ1B;IAgBI,iCAAiC;IACjC,qCAAqC;IACrC,mBAAmB;IACnB,UAAU,EAAA;;AAId,4BAAA;AACA;EACE,SAAO;EACP,qCAAqC;EACrC,kCAAkC;EAClC,wBAAwB,EAAA;EAJ1B;IAOI,oCAAoC;IACpC,iCAAiC,EAAA;EARrC;IAYI,mCAAmC;IACnC,uCAAuC;IACvC,sBAAsB,EAAA;EAd1B;IAkBI,kCAAkC;IAClC,kCAAkC;IAClC,4BAA4B;IAC5B,mBAAmB,EAAA;;AAIvB,2BAAA;AACA;EACE,0CAA0C;EAC1C,eAAe,EAAA;;AAGjB;EACE;IACE,yBAAyB,EAAA,EAAA;;AAI7B,6BAAA;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,iBAAiB,EAAA;EARnB;IAWI,wBAAwB;IACxB,qBAAqB;IACrB,4BAA4B,EAAA;IAbhC;MAgBM,0BAA0B;MAC1B,8BAA8B,EAAA;EAjBpC;IAsBI,6BAA6B,EAAA;;AAIjC;;+EAxI+E;AA2I/E;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;EAC1C,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,aAAa;EACb,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B,EAAA;;AAGhC;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB,EAAA;;AAG1B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,0BAA0B,EAAA;EAX5B;IAcI,oCAAoC;IACpC,wBAAwB,EAAA;EAf5B;IAmBI,WAAW;IACX,YAAY,EAAA;;AAIhB;EACE,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAA;;AAGX;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB,EAAA;;AAG1B;EACE,SAAO;EACP,+BAA+B;EAC/B,eAAe;EACf,WAAW,EAAA;;AAGb;EACE,wBAAwB;EACxB,oCAAoC;EACpC,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe,EAAA;;AAGjB;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,8CAA8C;EAC9C,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,aAAa,EAAA;;AAGf;EACE,kDAAkD;EAClD,6CAA6C;EAC7C,yBAAyB,EAAA;EAH3B;IAMI,+CAA+C;IAC/C,6CAA6C,EAAA;EAPjD;IAWI,8CAA8C;IAC9C,sBAAsB,EAAA;;AAI1B;EACE,uBAAuB;EACvB,iDAAiD;EACjD,+CAA+C,EAAA;EAHjD;IAMI,8BAA8B,EAAA;EANlC;IAUI,8BAA8B;IAC9B,sBAAsB,EAAA;EAX1B;IAeI,eAAe,EAAA;;AAInB;;+EAlK+E;AAsK/E,2CAAA;AACA;EACE;IACE,kBAAkB,EAAA;EAGpB;IACE,kBAAkB,EAAA;EAGpB;IACE,eAAe;IACf,iBAAiB,EAAA;EAGnB;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB,EAAA;EAGlB;IACE,gBAAgB,EAAA;EAGlB;IACE,gBAAgB,EAAA;EAGlB;IACE,eAAe;IACf,iBAAiB,EAAA;EAGnB;IACE,SAAS,EAAA;EAGX;IACE,YAAY,EAAA;EAGd;IACE,YAAY,EAAA;EAGd;IACE,YAAY,EAAA;EAGd;IACE,YAAY,EAAA,EACb;;AAGH,oCAAA;AACA;EACE;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,cAAc,EAAA;EAGhB;IACE,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB,EAAA;EAGpB;IACE,aAAa,EAAA;EAGf;IACE,gBAAgB,EAAA;EAGlB;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB,EAAA;EAGxB;IACE,eAAe;IACf,eAAe;IACf,iBAAiB,EAAA;EAGnB;;IAEE,aAAa,EAAA;EAGf;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB,EAAA;EAGzB;IACE,gBAAgB,EAAA,EACjB;;AAGH,mCAAA;AACA;EACE;IACE,aAAa,EAAA;EAGf;IACE,WAAW;IACX,uBAAuB,EAAA;EAGzB;IACE,eAAe;IACf,iBAAiB,EAAA;EAGnB;IACE,QAAQ,EAAA;EAGV;IACE,YAAY;IACZ,QAAQ;IACR,iBAAiB;IACjB,eAAe,EAAA;EAGjB;IACE,aAAa,EAAA;EAGf;IACE,0BAA0B;IAC1B,SAAS,EAAA;EAGX;IACE,8BAA8B,EAAA;EAGhC;IACE,WAAW,EAAA;EAGb;IACE,aAAa,EAAA;EAGf;IACE,aAAa,EAAA,EACd;;AAGH;;EAEE,8BAA8B,EAAA;;AAEhC;;;EAGE,0CAA0C;EAC1C,6DAA6D;EAC7D,8BAA8B,EAAA","sourcesContent":[":root {\n  --setup-teal: var(--interactive-default);\n  --setup-teal-hover: var(--interactive-hover);\n  --setup-teal-active: var(--interactive-pressed);\n  --setup-teal-light: var(--interactive-soft);\n  --setup-teal-pill: var(--interactive-selected);\n  --setup-text: var(--text-primary);\n  --setup-secondary: var(--text-secondary);\n  --setup-border: var(--border-default);\n  --setup-input-border: var(--border-strong);\n  --setup-disabled: var(--interactive-disabled);\n  --setup-error: var(--danger-default);\n  --font-family-primary: \"Lexend\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.business-setup-page {\n  --setup-teal: var(--interactive-default);\n  --setup-teal-hover: var(--interactive-hover);\n  --setup-teal-active: var(--interactive-pressed);\n  --setup-teal-light: var(--interactive-soft);\n  --setup-teal-pill: var(--interactive-selected);\n  --setup-text: var(--text-primary);\n  --setup-secondary: var(--text-secondary);\n  --setup-border: var(--border-default);\n  --setup-input-border: var(--border-strong);\n  --setup-disabled: var(--interactive-disabled);\n  --setup-error: var(--danger-default);\n  --font-family-primary: \"Lexend\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n\n  display: flex;\n  height: 100vh;\n  max-height: 100vh;\n  overflow: hidden;\n  background: var(--surface-primary);\n  color: var(--setup-text);\n  font-family: var(--font-family-primary);\n  box-sizing: border-box;\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n}\n\n/* ==========================================================================\n   Left Branding Column (Figma: Branding Panel 736x900)\n   ========================================================================== */\n.business-setup-brand {\n  position: relative;\n  width: 51.111%;\n  height: 100vh;\n  overflow: hidden;\n  padding: clamp(28px, 4.5vh, 64px) clamp(32px, 4vw, 72px);\n  color: #ffffff;\n  background: linear-gradient(90deg, #2ee6ee 0%, #0fbac4 45%, #0a7489 100%);\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n}\n\n.business-setup-brand-content {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 0;\n}\n\n.business-setup-brand-logo {\n  width: 262px;\n  height: 57px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.business-setup-brand-copy {\n  margin-top: clamp(16px, 2.8vh, 32px);\n}\n\n.business-setup-brand-copy h1 {\n  max-width: 576px;\n  margin: 0;\n  font-size: clamp(32px, 4.2vh, 54px);\n  font-weight: 700;\n  line-height: 1.18;\n  letter-spacing: -1.5px;\n  color: #ffffff;\n}\n\n.business-setup-brand-copy p {\n  max-width: 520px;\n  margin: clamp(12px, 1.8vh, 20px) 0 0;\n  font-size: clamp(15px, 1.8vh, 18px);\n  font-weight: 400;\n  line-height: 1.55;\n  color: #ffffff;\n}\n\n.business-setup-progress {\n  display: grid;\n  margin: clamp(16px, 3vh, 36px) 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.business-setup-progress li {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-height: clamp(52px, 6.5vh, 72px);\n  padding: 0 12px;\n\n  &:not(:last-child)::after {\n    position: absolute;\n    top: 48px;\n    left: 27px;\n    width: 1px;\n    height: clamp(24px, 3.5vh, 40px);\n    background: rgba(255, 255, 255, 0.55);\n    content: \"\";\n  }\n\n  > span {\n    display: grid;\n    width: 32px;\n    height: 32px;\n    flex: 0 0 32px;\n    place-items: center;\n    border: 1px solid #ffffff;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.13);\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 20px;\n    color: #ffffff;\n    transition: all 0.2s ease;\n  }\n\n  &.is-active > span {\n    background: #ffffff;\n    color: #0fbac4;\n    border-color: #ffffff;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n  }\n\n  div {\n    display: grid;\n    gap: 2px;\n  }\n\n  strong {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 21px;\n    color: #ffffff;\n  }\n\n  small {\n    color: rgba(255, 255, 255, 0.82);\n    font-size: 12px;\n    line-height: 17px;\n  }\n}\n\n.business-setup-secure {\n  margin-top: auto;\n  padding-top: 16px;\n  font-size: 12px;\n  line-height: 16px;\n  color: #ffffff;\n  opacity: 0.92;\n}\n\n/* Background floating orbs */\n.business-setup-orb {\n  position: absolute;\n  border-radius: 50%;\n  pointer-events: none;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.business-setup-orb--one {\n  width: 516px;\n  height: 516px;\n  top: -205px;\n  left: -178px;\n}\n\n.business-setup-orb--two {\n  width: 140px;\n  height: 140px;\n  top: -60px;\n  right: -70px;\n}\n\n.business-setup-orb--three {\n  width: 416px;\n  height: 416px;\n  right: -208px;\n  bottom: -274px;\n  background: rgba(5, 78, 104, 0.12);\n}\n\n/* ==========================================================================\n   Right Form Panel (Figma: Form Panel · Business setup 704x900)\n   ========================================================================== */\n.business-setup-panel {\n  position: relative;\n  display: flex;\n  width: 48.889%;\n  height: 100vh;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: clamp(20px, 3.5vh, 48px) clamp(24px, 4vw, 64px);\n  background: var(--surface-primary);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.business-setup-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 576px;\n  margin: 0 auto;\n  flex: 1 0 auto;\n  min-height: 0;\n}\n\n.business-setup-content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: clamp(14px, 2vh, 22px);\n}\n\n/* Headings (Figma: Screen Heading) */\n.business-setup-heading {\n  display: grid;\n  gap: 6px;\n}\n\n.business-setup-step-row {\n  display: flex;\n  min-height: 32px;\n  align-items: center;\n  justify-content: space-between;\n  color: var(--setup-teal);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n  letter-spacing: 0.07px;\n}\n\n.business-setup-skip-btn {\n  border: 0;\n  padding: 6px 12px;\n  color: var(--setup-teal);\n  background: transparent;\n  font: 500 13px var(--font-family-primary);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  &:hover:not(:disabled) {\n    background: var(--setup-teal-light);\n    color: var(--setup-teal-hover);\n  }\n\n  &:active:not(:disabled) {\n    background: var(--interactive-selected);\n    color: var(--setup-teal-active);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.business-setup-heading h2 {\n  margin: 0;\n  font-size: clamp(28px, 3.5vh, 40px);\n  font-weight: 300;\n  line-height: 1.2;\n  letter-spacing: -0.6px;\n  color: var(--setup-text);\n}\n\n.business-setup-heading p {\n  margin: 0;\n  color: var(--setup-secondary);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* Fields Stack (Figma: Business identity form) */\n.business-setup-fields {\n  display: grid;\n  gap: clamp(10px, 1.6vh, 16px);\n}\n\n/* Logo Upload Container */\n.business-logo-upload {\n  display: flex;\n  min-height: 76px;\n  align-items: center;\n  gap: 14px;\n  padding: 10px 14px;\n  border: 1px solid var(--setup-border);\n  border-radius: 14px;\n  background: var(--surface-primary);\n  transition: border-color 0.15s ease;\n\n  &:hover {\n    border-color: var(--border-strong);\n  }\n}\n\n.business-logo-avatar {\n  display: grid;\n  width: 52px;\n  height: 52px;\n  flex: 0 0 52px;\n  place-items: center;\n  overflow: hidden;\n  border-radius: 50%;\n  background: var(--setup-teal-light);\n  color: var(--setup-teal);\n\n  svg {\n    width: 26px;\n    height: 26px;\n  }\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.business-logo-info {\n  display: grid;\n  flex: 1;\n  gap: 2px;\n  min-width: 0;\n}\n\n.business-logo-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  strong {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 18px;\n    color: var(--setup-text);\n  }\n}\n\n.business-logo-optional-tag {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  color: var(--text-secondary);\n}\n\n.business-logo-info small,\n.business-setup-field small {\n  color: var(--setup-secondary);\n  font-size: 13px;\n  line-height: 16px;\n}\n\n.business-logo-upload-btn {\n  height: 36px;\n  padding: 0 16px;\n  border: 1px solid var(--setup-border);\n  border-radius: 10px;\n  background: var(--surface-primary);\n  color: var(--setup-text);\n  font: 500 13px var(--font-family-primary);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n\n  &:hover {\n    background: var(--surface-secondary);\n    border-color: var(--border-strong);\n  }\n\n  &:active {\n    background: var(--surface-tertiary);\n    border-color: var(--setup-input-border);\n    transform: scale(0.98);\n  }\n}\n\n/* Field Labels & Inputs */\n.business-setup-field {\n  display: grid;\n  gap: 6px;\n}\n\n.business-setup-field-label,\n.business-type-field legend {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n  color: var(--setup-text);\n}\n\n.required-marker {\n  color: var(--setup-error);\n  font-weight: 500;\n}\n\n.business-setup-input {\n  width: 100%;\n  height: 48px;\n  padding: 0 16px;\n  border: 1px solid var(--setup-input-border);\n  border-radius: 14px;\n  outline: none;\n  background: var(--surface-primary);\n  color: var(--setup-text);\n  font: 400 16px/20px var(--font-family-primary);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &::placeholder {\n    color: var(--text-secondary);\n  }\n\n  &:hover {\n    border-color: var(--setup-teal);\n  }\n\n  &:focus {\n    border: 2px solid var(--setup-teal);\n    box-shadow: none;\n    padding: 0 15px;\n  }\n}\n\n.business-setup-error {\n  color: var(--setup-error) !important;\n  font-size: 13px !important;\n  line-height: 16px !important;\n  font-weight: 400;\n}\n\n.business-setup-hint {\n  color: var(--setup-secondary);\n  font-size: 13px;\n  line-height: 16px;\n}\n\n/* Organisation Type Field Cards */\n.business-type-field {\n  display: grid;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.business-type-cards {\n  display: flex;\n  gap: 16px;\n}\n\n.business-type-card {\n  display: flex;\n  height: clamp(60px, 7.5vh, 76px);\n  flex: 1;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 16px;\n  border: 1px solid var(--setup-border);\n  border-radius: 14px;\n  background: var(--surface-primary);\n  color: var(--setup-text);\n  font: 500 16px var(--font-family-primary);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  outline: none;\n\n  &:hover {\n    border-color: var(--interactive-default);\n    background: var(--surface-secondary);\n  }\n\n  &:active {\n    transform: scale(0.99);\n  }\n\n  &.is-selected {\n    border: 1.5px solid var(--setup-teal);\n    background: var(--setup-teal-light);\n  }\n}\n\n.business-type-icon-box {\n  display: grid;\n  width: 42px;\n  height: 42px;\n  flex: 0 0 42px;\n  place-items: center;\n  border-radius: 10px;\n  background: var(--surface-secondary);\n  color: var(--setup-secondary);\n  transition: all 0.15s ease;\n\n  .is-selected & {\n    background: var(--interactive-soft-hover);\n    color: var(--setup-teal);\n  }\n\n  svg {\n    width: 22px;\n    height: 22px;\n  }\n}\n\n.business-type-title {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  color: var(--setup-text);\n}\n\n.business-type-check-badge {\n  display: grid;\n  width: 22px;\n  height: 22px;\n  margin-left: auto;\n  place-items: center;\n  border: 1.5px solid var(--setup-border);\n  border-radius: 50%;\n  font-style: normal;\n  background: var(--surface-primary);\n  transition: all 0.15s ease;\n\n  .is-selected & {\n    border-color: var(--setup-teal);\n    background: var(--setup-teal);\n    color: var(--on-interactive-primary);\n  }\n\n  svg {\n    width: 14px;\n    height: 14px;\n  }\n}\n\n.business-setup-field-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.business-setup-themed-select .quotation-figma-dropdown-trigger {\n  height: 48px;\n  padding: 0 16px;\n  border: 1px solid var(--setup-input-border);\n  border-radius: 14px;\n  background: var(--surface-primary);\n  color: var(--setup-text);\n  font: 400 14px/20px var(--font-family-primary);\n  &:hover {\n    border-color: var(--setup-teal);\n  }\n}\n\n.business-setup-themed-select.is-open .quotation-figma-dropdown-trigger,\n.business-setup-themed-select .quotation-figma-dropdown-trigger:focus-visible {\n  border: 2px solid var(--setup-teal);\n  padding-inline: 15px;\n  box-shadow: none;\n}\n\n.business-setup-themed-select .quotation-figma-dropdown-trigger.error {\n  border-color: var(--setup-error);\n}\n\n.business-setup-page .rcti-eligibility-select .quotation-figma-dropdown-trigger {\n  min-height: 42px;\n  height: 42px;\n  padding-inline: 12px 10px;\n  border-radius: 14px;\n  font: 400 14px/20px var(--font-family-primary);\n}\n\n/* Notice Box (Step 3: Banking) */\n.business-setup-notice {\n  display: flex;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: 14px;\n  background: var(--setup-teal-light);\n  color: var(--setup-teal);\n\n  .notice-icon {\n    width: 20px;\n    height: 20px;\n    flex: 0 0 20px;\n    margin-top: 1px;\n  }\n\n  div {\n    display: grid;\n    gap: 3px;\n    font-size: 14px;\n    line-height: 1.45;\n  }\n\n  strong {\n    font-weight: 500;\n    color: var(--setup-teal);\n  }\n\n  span {\n    color: var(--interactive-hover);\n    font-size: 13px;\n  }\n}\n\n/* ==========================================================================\n   Buttons & Interactive States (Figma: Button System 80:992)\n   ========================================================================== */\n.business-setup-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: clamp(16px, 2.5vh, 28px);\n  padding-top: 0;\n}\n\n.business-setup-button {\n  height: 48px;\n  padding: 0 24px;\n  border-radius: 14px;\n  font: 500 16px/20px var(--font-family-primary);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  outline: none;\n\n  &:focus-visible {\n    box-shadow: none;\n    outline: 2px solid var(--focus-ring, #0f766e);\n    outline-offset: 2px;\n  }\n}\n\n/* Primary Button (Continue / Finish setup) */\n.business-setup-button--primary {\n  flex: 1;\n  border: 0;\n  background: var(--setup-teal);\n  color: var(--on-interactive-primary);\n\n  &:hover:not(:disabled) {\n    background: var(--setup-teal-hover);\n  }\n\n  &:active:not(:disabled) {\n    background: var(--setup-teal-active);\n    transform: scale(0.99);\n  }\n\n  &:disabled {\n    background: var(--setup-disabled);\n    color: var(--on-interactive-disabled);\n    cursor: not-allowed;\n    opacity: 1;\n  }\n}\n\n/* Secondary Button (Back) */\n.business-setup-button--secondary {\n  flex: 1;\n  border: 1px solid var(--setup-border);\n  background: var(--surface-primary);\n  color: var(--setup-text);\n\n  &:hover:not(:disabled) {\n    background: var(--surface-secondary);\n    border-color: var(--setup-border);\n  }\n\n  &:active:not(:disabled) {\n    background: var(--surface-tertiary);\n    border-color: var(--setup-input-border);\n    transform: scale(0.99);\n  }\n\n  &:disabled {\n    background: var(--surface-primary);\n    border-color: var(--border-subtle);\n    color: var(--text-secondary);\n    cursor: not-allowed;\n  }\n}\n\n/* Button Loading Spinner */\n.business-btn-spin {\n  animation: spinLoader 0.9s linear infinite;\n  font-size: 18px;\n}\n\n@keyframes spinLoader {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Footer (Privacy & Terms) */\n.business-setup-footer {\n  position: static;\n  margin-top: clamp(16px, 2vh, 24px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 13px;\n  line-height: 18px;\n\n  a {\n    color: var(--setup-teal);\n    text-decoration: none;\n    transition: color 0.15s ease;\n\n    &:hover {\n      text-decoration: underline;\n      color: var(--setup-teal-hover);\n    }\n  }\n\n  span {\n    color: var(--setup-secondary);\n  }\n}\n\n/* ==========================================================================\n   Crop Logo Modal (Clean, Dedicated, Never Cut Off)\n   ========================================================================== */\n.business-crop-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90vw;\n  max-width: 460px;\n  max-height: 90vh;\n  padding: 20px 24px;\n  border-radius: 16px;\n  background: var(--surface-primary);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 16px !important;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.business-crop-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.business-crop-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 24px;\n  color: var(--setup-text);\n}\n\n.business-crop-close-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: none;\n  background: transparent;\n  color: var(--setup-secondary);\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  &:hover {\n    background: var(--surface-secondary);\n    color: var(--setup-text);\n  }\n\n  svg {\n    width: 18px;\n    height: 18px;\n  }\n}\n\n.business-crop-area {\n  position: relative;\n  width: 100%;\n  height: clamp(240px, 40vh, 320px);\n  border-radius: 12px;\n  overflow: hidden;\n  background: #0e1a18;\n}\n\n.business-crop-zoom-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.business-crop-zoom-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--setup-text);\n}\n\n.business-crop-zoom-slider {\n  flex: 1;\n  accent-color: var(--setup-teal);\n  cursor: pointer;\n  height: 6px;\n}\n\n.business-crop-actions {\n  display: flex !important;\n  justify-content: flex-end !important;\n  align-items: center !important;\n  gap: 12px !important;\n  margin-top: 4px;\n}\n\n.business-crop-btn {\n  height: 40px;\n  padding: 0 20px;\n  border-radius: 10px;\n  font: 500 14px/18px var(--font-family-primary);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  transition: all 0.15s ease;\n  outline: none;\n}\n\n.business-crop-btn--cancel {\n  border: 1px solid var(--border-default) !important;\n  background: var(--surface-primary) !important;\n  color: #142624 !important;\n\n  &:hover {\n    background: var(--surface-secondary) !important;\n    border-color: var(--border-strong) !important;\n  }\n\n  &:active {\n    background: var(--surface-tertiary) !important;\n    transform: scale(0.98);\n  }\n}\n\n.business-crop-btn--save {\n  border: none !important;\n  background: var(--interactive-default) !important;\n  color: var(--on-interactive-primary) !important;\n\n  &:hover {\n    background: #0c5f59 !important;\n  }\n\n  &:active {\n    background: #0a4a46 !important;\n    transform: scale(0.98);\n  }\n\n  svg {\n    font-size: 16px;\n  }\n}\n\n/* ==========================================================================\n   Responsive Adaptations\n   ========================================================================== */\n\n/* Short laptop screens (<= 800px height) */\n@media (max-height: 800px) and (min-width: 1024px) {\n  .business-setup-panel {\n    padding: 20px 48px;\n  }\n\n  .business-setup-brand {\n    padding: 24px 48px;\n  }\n\n  .business-setup-brand-copy h1 {\n    font-size: 34px;\n    line-height: 1.15;\n  }\n\n  .business-setup-brand-copy p {\n    font-size: 14px;\n    line-height: 1.45;\n    margin-top: 10px;\n  }\n\n  .business-setup-progress {\n    margin-top: 18px;\n  }\n\n  .business-setup-progress li {\n    min-height: 54px;\n  }\n\n  .business-setup-heading h2 {\n    font-size: 28px;\n    line-height: 1.18;\n  }\n\n  .business-setup-fields {\n    gap: 10px;\n  }\n\n  .business-setup-input {\n    height: 44px;\n  }\n\n  .business-setup-themed-select .quotation-figma-dropdown-trigger {\n    height: 44px;\n  }\n\n  .business-type-card {\n    height: 58px;\n  }\n\n  .business-setup-button {\n    height: 44px;\n  }\n}\n\n/* Tablet Flow (max-width: 1023px) */\n@media (max-width: 1023px) {\n  .business-setup-page {\n    display: block;\n    height: auto;\n    max-height: none;\n    overflow: auto;\n  }\n\n  .business-setup-brand {\n    width: 100%;\n    min-height: 240px;\n    height: auto;\n    padding: 40px 32px;\n  }\n\n  .business-setup-brand-content {\n    min-height: 0;\n  }\n\n  .business-setup-brand-copy {\n    margin-top: 16px;\n  }\n\n  .business-setup-brand-copy h1 {\n    font-size: 32px;\n    line-height: 42px;\n    letter-spacing: -0.5px;\n  }\n\n  .business-setup-brand-copy p {\n    margin-top: 6px;\n    font-size: 14px;\n    line-height: 22px;\n  }\n\n  .business-setup-progress,\n  .business-setup-secure {\n    display: none;\n  }\n\n  .business-setup-panel {\n    width: 100%;\n    height: auto;\n    min-height: auto;\n    padding: 48px 32px 32px;\n  }\n\n  .business-setup-form {\n    min-height: auto;\n  }\n}\n\n/* Mobile Flow (max-width: 599px) */\n@media (max-width: 599px) {\n  .business-setup-brand {\n    display: none;\n  }\n\n  .business-setup-panel {\n    width: 100%;\n    padding: 32px 16px 24px;\n  }\n\n  .business-setup-heading h2 {\n    font-size: 26px;\n    line-height: 32px;\n  }\n\n  .business-type-cards {\n    gap: 8px;\n  }\n\n  .business-type-card {\n    height: 48px;\n    gap: 8px;\n    padding: 8px 12px;\n    font-size: 14px;\n  }\n\n  .business-type-icon-box {\n    display: none;\n  }\n\n  .business-setup-field-row {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .business-setup-actions {\n    flex-direction: column-reverse;\n  }\n\n  .business-setup-button--secondary {\n    width: 100%;\n  }\n\n  .business-crop-modal {\n    padding: 16px;\n  }\n\n  .business-crop-area {\n    height: 240px;\n  }\n}\n\n.business-setup-input,\n.business-setup-themed-select .quotation-figma-dropdown-trigger {\n  caret-color: var(--setup-text);\n}\n.business-setup-input:-webkit-autofill,\n.business-setup-input:-webkit-autofill:hover,\n.business-setup-input:-webkit-autofill:focus {\n  -webkit-text-fill-color: var(--setup-text);\n  -webkit-box-shadow: 0 0 0 1000px var(--surface-primary) inset;\n  caret-color: var(--setup-text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
